import css from './checkbox.module.scss'

export const Checkbox = ({ children, label, onChange, value, checked, name = '', id, higlighted, higlightedLink }) => {
    return (
        <label className={css.container}>
            {children ? children : ''}
            {label ? label : ''}
            {higlighted ? <span style={{color:'var(--primary-color)', cursor:'pointer'}} onClick={higlightedLink}> {higlighted}.</span> : ''}
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                value={value}
                name={name}
                id={id}
            />
            <span className={css.checkmark} />
        </label>
    )
}
